// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .cell[data-v-73e7484e] {\r\n  display: table-cell !important;\r\n  vertical-align: middle;\r\n  text-align: center;\n}\n.channl[data-v-73e7484e] {\r\n  margin: 10px 0 10px;\n}\n.dropdown[data-v-73e7484e] {\r\n  float: right;\n}\n.title[data-v-73e7484e] {\r\n  display: inline;\r\n  margin-right: 10px;\n}\n.el-button[data-v-73e7484e] {\r\n  margin-top: 10px;\n}\n.el-dropdown[data-v-73e7484e] {\r\n  display: inline;\n}\r\n", ""]);
// Exports
module.exports = exports;
